import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["element-loading-text"];
const _hoisted_2 = {
  class: "inner"
};
const _hoisted_3 = {
  class: "user-profile"
};
const _hoisted_4 = {
  class: "product-box"
};
const _hoisted_5 = {
  key: 0,
  class: "info"
};
const _hoisted_6 = {
  class: "product-item"
};
const _hoisted_7 = {
  class: "image-container mt-[20px]"
};
const _hoisted_8 = {
  class: "product-title"
};
const _hoisted_9 = {
  class: "name"
};
const _hoisted_10 = {
  class: "product-info"
};
const _hoisted_11 = {
  class: "info-line"
};
const _hoisted_12 = {
  class: "price"
};
const _hoisted_13 = {
  class: "info-line"
};
const _hoisted_14 = {
  class: "discount"
};
const _hoisted_15 = {
  class: "info-line"
};
const _hoisted_16 = {
  key: 0,
  class: "expire"
};
const _hoisted_17 = {
  key: 1,
  class: "expire"
};
const _hoisted_18 = {
  class: "info-line"
};
const _hoisted_19 = {
  class: "power"
};
const _hoisted_20 = {
  class: "pay-way"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  key: 3,
  class: "box-card"
};
const _hoisted_23 = {
  class: "headline flex items-center"
};
const _hoisted_24 = {
  class: "user-order"
};
const _hoisted_25 = {
  key: 0
};
const _hoisted_26 = {
  class: "product-info"
};
const _hoisted_27 = {
  class: "price"
};
const _hoisted_28 = {
  style: {
    "padding-bottom": "10px",
    "text-align": "center"
  }
};
import nodata from "@/assets/img/no-data.png";
import { onMounted, ref } from "vue";
import { ElMessage } from "element-plus";
import { httpGet, httpPost } from "@/utils/http";
import { checkSession, getSystemInfo } from "@/store/cache";
import UserProfile from "@/components/UserProfile.vue";
import RedeemVerify from "@/components/RedeemVerify.vue";
import UserOrder from "@/components/UserOrder.vue";
import { useSharedStore } from "@/store/sharedata";
import QRCode from "qrcode";
export default /*@__PURE__*/_defineComponent({
  __name: 'Member',
  setup(__props) {
    const list = ref([]);
    const vipImg = ref("/images/menu/member.png");
    const enableReward = ref(false); // 是否启用众筹功能
    const rewardImg = ref("/images/reward.png");
    const showPasswordDialog = ref(false);
    const showBindMobileDialog = ref(false);
    const showBindEmailDialog = ref(false);
    const showRedeemVerifyDialog = ref(false);
    const showThirdLoginDialog = ref(false);
    const user = ref(null);
    const isLogin = ref(false);
    const orderTimeout = ref(1800);
    const loading = ref(true);
    const loadingText = ref("加载中...");
    const orderPayInfoText = ref("");
    const payWays = ref([]);
    const vipInfoText = ref("");
    const store = useSharedStore();
    const profileKey = ref(0);
    const userOrderKey = ref(0);
    const showDialog = ref(false);
    const qrImg = ref("");
    const price = ref(0);
    const showUserOrder = ref(false);
    onMounted(() => {
      checkSession().then(_user => {
        user.value = _user;
        isLogin.value = true;
      }).catch(() => {
        store.setShowLoginDialog(true);
      });
      httpGet("/ai/product/list").then(res => {
        list.value = res;
        loading.value = false;
      }).catch(e => {
        ElMessage.error("获取产品套餐失败：" + e.message);
      });
      getSystemInfo().then(res => {
        rewardImg.value = res.data["reward_img"];
        enableReward.value = res.data["enabled_reward"];
        orderPayInfoText.value = res.data["order_pay_info_text"];
        if (res.data["order_pay_timeout"] > 0) {
          orderTimeout.value = res.data["order_pay_timeout"];
        }
        vipInfoText.value = res.data["vip_info_text"];
      }).catch(e => {
        ElMessage.error("获取系统配置失败：" + e.message);
      });
      // httpGet("/payment/payWays")
      httpGet("/pay/channel/list").then(res => {
        payWays.value = res;
      }).catch(e => {
        ElMessage.error("获取支付方式失败：" + e.message);
      });
    });
    const pay = (product, payWay) => {
      if (!isLogin.value) {
        store.setShowLoginDialog(true);
        return;
      }
      loading.value = true;
      loadingText.value = "正在生成支付订单...";
      let host = process.env.VUE_APP_API_HOST;
      if (host === "") {
        host = `${location.protocol}//${location.host}`;
      }
      // todo
      // httpPost(`${process.env.VUE_APP_API_HOST}/api/payment/doPay`, {
      httpPost(`/trade/order/create`, {
        // product_id: product.id,
        // pay_way: payWay.pay_way,
        // pay_type: payWay.pay_type,
        // user_id: user.value.id,
        // host: host,
        // device: "jump",
        productId: product.id,
        channelCode: payWay.pay_way
      }).then(res => {
        showDialog.value = true;
        loading.value = false;
        if (payWay.pay_way === "wx_native") {
          price.value = Number(product.discount);
          QRCode.toDataURL(res.displayContent, {
            width: 300,
            height: 300,
            margin: 2
          }, (error, url) => {
            if (error) {
              console.error(error);
            } else {
              qrImg.value = url;
            }
          });
        } else {
          window.open(res.displayContent, "_blank");
        }
      }).catch(e => {
        setTimeout(() => {
          ElMessage.error("生成支付订单失败：" + e.message);
          loading.value = false;
        }, 500);
      });
    };
    const redeemCallback = success => {
      showRedeemVerifyDialog.value = false;
      if (success) {
        profileKey.value += 1;
      }
    };
    const payCallback = success => {
      showDialog.value = false;
      if (success) {
        profileKey.value += 1;
        userOrderKey.value += 1;
      }
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_alert = _resolveComponent("el-alert");
      const _component_Icon = _resolveComponent("Icon");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", null, [_withDirectives((_openBlock(), _createElementBlock("div", {
        class: "member custom-scroll",
        "element-loading-background": "rgba(255,255,255,.3)",
        "element-loading-text": loadingText.value
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(), _createBlock(UserProfile, {
        key: profileKey.value,
        edit: false
      })), _createVNode(_component_el_row, {
        class: "user-opt",
        gutter: 20
      }, {
        default: _withCtx(() => [false ? (_openBlock(), _createBlock(_component_el_col, {
          key: 0,
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            disabled: true,
            type: "primary",
            onClick: _cache[0] || (_cache[0] = $event => showRedeemVerifyDialog.value = true)
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("卡密兑换 ")])),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = $event => showUserOrder.value = true)
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("消费账单 ")])),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [false && orderPayInfoText.value !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_alert, {
        type: "success",
        "show-icon": "",
        closable: false,
        effect: "dark"
      }, {
        default: _withCtx(() => [_cache[8] || (_cache[8] = _createElementVNode("strong", null, "说明:", -1)), _createTextVNode(" " + _toDisplayString(vipInfoText.value), 1)]),
        _: 1
      })])) : _createCommentVNode("", true), list.value.length > 0 && !showUserOrder.value ? (_openBlock(), _createBlock(_component_el_row, {
        key: 1,
        gutter: 20,
        class: "list-box"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, item => {
          return _openBlock(), _createBlock(_component_el_col, {
            key: item.id,
            span: 6
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_Icon, {
              class: "icon !text-[--code-text-color]",
              icon: "majesticons:creditcard-plus",
              size: 48
            })]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(item.name), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_cache[9] || (_cache[9] = _createElementVNode("span", {
              class: "label"
            }, "商品原价：", -1)), _createElementVNode("span", _hoisted_12, [_createElementVNode("del", null, "￥" + _toDisplayString(item.price), 1)])]), _createElementVNode("div", _hoisted_13, [_cache[10] || (_cache[10] = _createElementVNode("span", {
              class: "label"
            }, "优惠价：", -1)), _createElementVNode("span", _hoisted_14, "￥" + _toDisplayString(item.discount), 1)]), _createElementVNode("div", _hoisted_15, [_cache[11] || (_cache[11] = _createElementVNode("span", {
              class: "label"
            }, "有效期：", -1)), item.days > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(item.days) + "天", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_17, "长期有效"))]), _createElementVNode("div", _hoisted_18, [_cache[12] || (_cache[12] = _createElementVNode("span", {
              class: "label"
            }, "算力值：", -1)), _createElementVNode("span", _hoisted_19, _toDisplayString(item.power), 1)]), _createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payWays.value, (payWay, index) => {
              return _openBlock(), _createElementBlock("span", {
                type: "primary",
                onClick: $event => pay(item, payWay),
                key: index
              }, [payWay.pay_type === 'alipay' ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                color: "#15A6E8",
                circle: ""
              }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [_createElementVNode("i", {
                  class: "iconfont icon-alipay"
                }, null, -1)])),
                _: 1
              })) : payWay.pay_type === 'qqpay' ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                circle: ""
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [_createElementVNode("i", {
                  class: "iconfont icon-qq"
                }, null, -1)])),
                _: 1
              })) : payWay.pay_type === 'paypal' ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                class: "paypal",
                round: ""
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [_createElementVNode("i", {
                  class: "iconfont icon-paypal"
                }, null, -1)])),
                _: 1
              })) : payWay.pay_type === 'jdpay' ? (_openBlock(), _createBlock(_component_el_button, {
                key: 3,
                color: "#E1251B",
                circle: ""
              }, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [_createElementVNode("i", {
                  class: "iconfont icon-jd-pay"
                }, null, -1)])),
                _: 1
              })) : payWay.pay_type === 'douyin' ? (_openBlock(), _createBlock(_component_el_button, {
                key: 4,
                class: "douyin",
                circle: ""
              }, {
                default: _withCtx(() => _cache[17] || (_cache[17] = [_createElementVNode("i", {
                  class: "iconfont icon-douyin"
                }, null, -1)])),
                _: 1
              })) : (_openBlock(), _createBlock(_component_el_button, {
                key: 5,
                circle: "",
                class: "wechat",
                color: "#67C23A"
              }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [_createElementVNode("i", {
                  class: "iconfont icon-wechat-pay"
                }, null, -1)])),
                _: 1
              }))], 8, _hoisted_21);
            }), 128))])])])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })) : !showUserOrder.value ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 2,
        description: "暂无数据",
        image: _unref(nodata)
      }, null, 8, ["image"])) : _createCommentVNode("", true), showUserOrder.value ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("h2", _hoisted_23, [_createVNode(_component_el_button, {
        text: "",
        onClick: _cache[2] || (_cache[2] = $event => showUserOrder.value = false),
        size: "small"
      }, {
        icon: _withCtx(() => [_createVNode(_component_Icon, {
          icon: "material-symbols-light:cancel-outline",
          size: 24
        })]),
        _: 1
      }), _cache[19] || (_cache[19] = _createTextVNode(" 消费账单 "))]), _createElementVNode("div", _hoisted_24, [isLogin.value ? (_openBlock(), _createBlock(UserOrder, {
        key: userOrderKey.value
      })) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)])]), isLogin.value ? (_openBlock(), _createBlock(RedeemVerify, {
        key: 0,
        show: showRedeemVerifyDialog.value,
        onHide: redeemCallback
      }, null, 8, ["show"])) : _createCommentVNode("", true)], 8, _hoisted_1)), [[_directive_loading, loading.value]]), _createVNode(_component_el_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => showDialog.value = $event),
        "show-close": false,
        "close-on-click-modal": false,
        "hide-footer": "",
        width: "auto",
        class: "pay-dialog"
      }, {
        default: _withCtx(() => [qrImg.value !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_cache[20] || (_cache[20] = _createTextVNode(" 请使用微信扫码支付：")), _createElementVNode("span", _hoisted_27, "￥" + _toDisplayString(price.value), 1)]), _createVNode(_component_el_image, {
          src: qrImg.value,
          fit: "cover"
        }, null, 8, ["src"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_28, [_createVNode(_component_el_button, {
          type: "success",
          onClick: _cache[3] || (_cache[3] = $event => payCallback(true))
        }, {
          default: _withCtx(() => _cache[21] || (_cache[21] = [_createTextVNode("支付成功")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[4] || (_cache[4] = $event => payCallback(false))
        }, {
          default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode("支付失败")])),
          _: 1
        })])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});